export const CycleStatus = {
  Active: "Active",
  Inactive: "Inactive",
  Locked: "Locked",
};
